import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';

import '../styles/components/nav.scss';


import logo from '../assets/logo.svg';


export default class Nav extends Component {

  state = {
    open: false
  }

  constructor(props) {
    super(props);
    this.nav = null;
  }

  toggleMenu = () => {
    this.setState({
      open: !this.state.open
    })
  }

  componentDidMount() {
    TweenMax.set(this.nav, {
      y: '-100px',
      visibility: 'visible'
    })

    TweenMax.to(this.nav, 1.5, {
      y: 0,
    })
  }

  render () {
    return (
      <div className="main-navigation"  ref={div => this.nav = div}>
        <nav>
          <div className="logo">
            <img src={ logo } alt='Vive Logo' />
          </div>
          <div className='menu'  onClick={this.toggleMenu}>
            <span className="menu-name">MENU</span>
            <div className="nav-icon">
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
              <span className={`${this.state.open ? 'open ' : ''}`}></span>
            </div>
          </div>
        </nav>
        <div className={`nav-links ${this.state.open ? 'open ' : ''}`}>
          <div className="contents">
            <Link to='/'>Products</Link>
            <Link to='/'>VIVEPORT</Link>
            <Link to='/'>Experiences</Link>
            <Link to='/'>Blog</Link>
            <Link to='/'>Support</Link>
          </div>
        </div>
      </div>
    )
  }

}
